// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f770e67f","667":"4f0d7aee","977":"ee657fa9"}[chunkId] + ".chunk.js";
};